import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';
import {SvgIconEl} from 'common/components/svg-icon';

import type {QueryEntrySection} from '../index';
import {QuerySuperEntry} from '../types';

export function RowLabel({
  el,
  index,
  isPlaceholder,
}: {
  el: QueryEntrySection;
  entry: QuerySuperEntry;
  index: number;
  isPlaceholder: boolean;
}) {
  const isClickable = !isPlaceholder && el.attr(`row-index-toggleable`);
  const prefix = el.attr(`row-label-prefix`);
  const hasPrefix = Boolean(prefix);
  const report = el.attr(`track-name`);
  const reportName = [`funnels`, `insights`, `retention`, `flows`].includes(report) && report;
  const extraClass = reportName ? {[`for-${reportName}`]: true} : {};
  return (
    <>
      {/** optional prefixed grouped label */}
      {hasPrefix && (!el.hasNewQBUI() ? index === 0 : true) && (
        <RowLabelContent
          icon={el.attr(`row-label-prefix-icon`)}
          label={prefix}
          isPlaceholder={isPlaceholder}
          clickHandler={isClickable && el.helpers.onGroupEntryIndexLabelClicked.bind(el)}
          extraClass={{'is-prefix': true, ...extraClass}}
        />
      )}
      <RowLabelContent
        icon={el.helpers.getRowIcon(index)}
        label={el.helpers.getRowLabel(index)}
        isPlaceholder={isPlaceholder}
        clickHandler={isClickable && !hasPrefix && el.helpers.onEntryIndexLabelClicked.bind(el, index)}
        hasPrefix={hasPrefix}
        extraClass={extraClass}
      />
    </>
  );
}

function RowLabelContent({
  icon,
  label,
  isPlaceholder,
  clickHandler,
  hasPrefix = false,
  extraClass,
}: {
  icon: string;
  label: string;
  isPlaceholder: boolean;
  clickHandler: (ev: MouseEvent) => void;
  hasPrefix?: boolean;
  extraClass?: Record<string, boolean>;
}) {
  const isClickable = Boolean(clickHandler);
  const slotName = !isClickable && `selector-icon`;
  return (
    <div
      key={`entry-label-${slotName}-${icon}`}
      sel='.mp-query-entry-label'
      class={{'is-placeholder': isPlaceholder, 'is-clickable': isClickable, ...extraClass}}
      attrs={{elref: `rowLabel`, slot: !isClickable && `selector-icon`}}
    >
      {label && (
        <ButtonEl
          attrs={{
            elref: `rowLabelButton`,
            theme: ButtonTheme.Tertiary,
            'not-focusable': !clickHandler,
          }}
          class={{
            'is-clickable': isClickable,
            'has-prefix': hasPrefix,
          }}
          on={{click: clickHandler}}
        >
          {icon ? <SvgIconEl attrs={{icon}} /> : <span>{label}</span>}
        </ButtonEl>
      )}
    </div>
  );
}
